export const pricingLayers = Object.freeze({
	JORNADA: 3,
	RECORRENCIA_BH: 4,
	RECORRENCIA_SP: 5
});
